import { render, staticRenderFns } from "./SideBarStyle1.vue?vue&type=template&id=1f88d5e2&"
import script from "./SideBarStyle1.vue?vue&type=script&lang=js&"
export * from "./SideBarStyle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports